import React, { ReactElement } from 'react';
import { renderOSIcon } from '../../../../utils/utils';
import styles from '../../../../VmNode.module.css';

export type OsIconProps = { asset?: VirtualMachine };

export function OsIcon({ asset }: OsIconProps): ReactElement {
  return <div className={styles.osIconWrapper}>{renderOSIcon(asset)}</div>;
}
